<!-- Loading Overlay Global al cambiar compañía (fuera del toolbar para evitar problemas de z-index) -->
@if(changingCompany) {
  <div class="company-change-overlay" role="alert" aria-live="assertive" aria-busy="true">
    <div class="company-change-content">
      <!-- Icono de edificio -->
      <div class="company-icon-wrapper">
        @if(!changeComplete) {
          <i-tabler name="building" class="icon-40 text-primary"></i-tabler>
        } @else {
          <i-tabler name="check" class="icon-40 text-success company-check-icon"></i-tabler>
        }
      </div>

      <!-- Progress bar -->
      <div class="company-progress-wrapper">
        <div class="company-progress-bar" [style.width.%]="changeProgress"></div>
      </div>

      <!-- Texto con nombre de compañía destino -->
      <p class="company-change-title">
        @if(!changeComplete) {
          Cambiando a <strong>{{ targetCompanyName }}</strong>
        } @else {
          ¡Listo!
        }
      </p>
      <p class="company-change-subtitle">Por favor espere...</p>
    </div>
  </div>
}

<mat-toolbar class="topbar">
  <!-- --------------------------------------------------------------- -->
  <!-- Desktop Menu -->
  @if(showToggle) {
  <button mat-icon-button (click)="toggleCollapsed.emit()" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }


  <!-- Mobile Menu -->
  @if(!showToggle) {
  <button mat-icon-button (click)="toggleMobileNav.emit()" class="d-flex justify-content-center">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  }

  <!-- Brand Logo -->
  <span class="brand-title" style="font-size: 1.4rem; font-weight: 700; letter-spacing: 0.5px; margin-left: 8px;">
    <span style="color: #ff9800;">m</span><span style="color: #ffffff;">Payroll 2.0</span>
  </span>

  <span class="flex-1-auto"></span>

  <!-- --------------------------------------------------------------- -->
  <!-- langugage Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button  mat-icon-button class="m-r-5">
    <img [src]="selectedLanguage.icon" class="rounded-circle object-cover icon-20" />
  </button> -->

  <!-- --------------------------------------------------------------- -->
  <!-- Companies Dropdown -->
  <!-- --------------------------------------------------------------- -->
<button
  mat-button
  [matMenuTriggerFor]="companiesmenu"
  aria-label="Companies"
  class="m-r-5"
  style="display:flex; align-items:center; gap:8px;"
>
  <!-- <span style="display:flex; align-items:center; line-height:0;">
    <i-tabler name="building" class="icon-20" style="display:block; line-height:0;"></i-tabler>
  </span> -->

    @if(selectedCompany) {
      <span class="f-s-14 f-w-500" style="line-height: 1.2;">{{ selectedCompany.Name }}</span>
    } @else {
      <span class="f-s-14 f-w-500 text-muted" style="line-height: 1.2;">Seleccionar compañía</span>
    }
    <i-tabler name="chevron-down" class="icon-16" style="margin-top: -2px;"></i-tabler>
  </button>
  <mat-menu #companiesmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16 b-b-1">
      <h6 class="f-s-16 f-w-600 m-0">Seleccionar Compañía</h6>
    </div>

    @if(loadingCompanies) {
      <div class="p-x-32 p-y-24 text-center" role="status" aria-live="polite">
        <mat-spinner diameter="30" class="m-auto"></mat-spinner>
        <p class="m-t-12 m-b-0 f-s-13 text-muted">Cargando compañías...</p>
      </div>
    }

    @if(!loadingCompanies && companies.length === 0) {
      <div class="p-x-32 p-y-16 text-center">
        <p class="m-0 text-muted">No hay compañías disponibles</p>
      </div>
    }

    @if(!loadingCompanies && companies.length > 0) {
      <div style="max-height: 400px; overflow-y: auto;">
        @for(company of companies; track company.IdCompany) {
          <button
            mat-menu-item
            class="p-x-32 p-y-16"
            (click)="selectCompany(company)"
            [class.bg-light-primary]="selectedCompany?.IdCompany === company.IdCompany">
            <div class="d-flex align-items-center">
              <div class="rounded-circle bg-light-primary d-flex align-items-center justify-content-center"
                   style="width: 32px; height: 32px;">
                <i-tabler name="building" class="icon-18 text-primary"></i-tabler>
              </div>
              <div class="m-l-12">
                <h6 class="f-s-14 f-w-600 m-0">{{ company.Name }}</h6>
                <span class="f-s-12 text-muted">{{ company.BusinessName }}</span>
              </div>
              @if(selectedCompany?.IdCompany === company.IdCompany) {
                <i-tabler name="check" class="icon-18 text-primary m-l-auto"></i-tabler>
              }
            </div>
          </button>
        }
      </div>
    }
  </mat-menu>

  <!-- --------------------------------------------------------------- -->
  <!-- Notification Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <!-- <button mat-icon-button [matMenuTriggerFor]="notificationmenu" aria-label="Notifications">
    <i-feather class="d-flex icon-18" name="bell" matBadge="1" matBadgeSize="small" matBadgeColor="primary"></i-feather>
  </button>
  <mat-menu #notificationmenu="matMenu" class="topbar-dd cardWithShadow">
    <div class="d-flex align-items-center p-x-32 p-y-16">
      <h6 class="f-s-16 f-w-600 m-0">Notifications</h6>
      <span class="m-l-auto">
        <span class="bg-primary text-white p-x-8 p-y-4 f-w-500 rounded f-s-12">5 new</span>
      </span>
    </div> -->
    <!-- @for(notification of notifications; track notification) {
    <button mat-menu-item class="p-x-32 p-y-16">
      <div class="d-flex align-items-center">
        <img [src]="notification.img" class="rounded-circle" width="48" />
        <div class="m-l-16">
          <h5 class="f-s-14 f-w-600 m-0 mat-subtitle-1">
            {{ notification.title }}
          </h5>
          <span>{{ notification.subtitle }}</span>
        </div>
      </div>
    </button>
    } -->

    <!-- <div class="p-y-12 p-x-32">
      <button mat-stroked-button color="primary" class="w-100">
        See all notifications
      </button>
    </div> -->
  <!-- </mat-menu> -->

  <!-- --------------------------------------------------------------- -->
  <!-- profile Dropdown -->
  <!-- --------------------------------------------------------------- -->
  <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications">
    <img [src]="userPicture" class="rounded-circle object-cover icon-35 profile-dd" width="35" />
  </button>
  <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
    <ng-scrollbar class="position-relative" style="height: 320px">
      <div class="p-x-32 p-y-16">
        <h6 class="f-s-16 f-w-600 m-0">Mi Perfil</h6>

        <div class="d-flex flex-column align-items-center p-b-24 b-b-1 m-t-16">
          <img [src]="userPicture" class="rounded-circle" width="95" />
          <div class="m-t-16 text-center">
            <h6 class="f-s-14 f-w-600 m-0">{{ userName }}</h6>
            <span class="f-s-13 text-muted d-block m-t-4">{{ userEmail }}</span>
          </div>
        </div>
      </div>

      <div class="p-y-12 p-x-32">
        <button (click)="logout()" mat-stroked-button color="primary" class="w-100">Cerrar sesión</button>
      </div>
    </ng-scrollbar>
  </mat-menu>
</mat-toolbar>
